//@ts-nocheck
import * as actions from './productionApiActions';
export const getCreditApplicationsByStatus = actions.getCreditApplicationsByStatus;
export const validateSSN = actions.validateSSN;
export const applyAfterPrequalification = actions.applyAfterPrequalification;
export const searchForPractices = actions.searchForPractices;
export const createCreditApplicationIdentityVerification = actions.createCreditApplicationIdentityVerification;
export const getCreditApplicationIdentityVerification = actions.getCreditApplicationIdentityVerification;
export const submitFullApplication = actions.submitFullApplication;
export const getLenderTerms = actions.getLenderTerms;
export const getPracticeLocations = actions.getPracticeLocations;
